module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_11_4.9bc9a372.jpeg";